<script lang="ts" setup>
import { ProgressSpinner } from 'primevue';
</script>

<template>
  <ProgressSpinner />
</template>
